import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';

let sessionPageCount = 0;
let sessionStartTime = Date.now();

/**
 * Tracks frontend page views + session activity.
 * Sends page view on navigation, session heartbeat on unload.
 */
export default function usePageTracking() {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    if (fullPath === lastTracked.current) return;
    lastTracked.current = fullPath;
    sessionPageCount++;

    axios.post(`${API}/analytics/track`, {
      page: location.pathname,
      title: document.title,
      referrer: document.referrer,
    }).catch(() => {});
  }, [location.pathname, location.search]);

  // Track session end on page unload
  useEffect(() => {
    const handleUnload = () => {
      const duration = Math.round((Date.now() - sessionStartTime) / 1000);
      const data = JSON.stringify({
        duration_seconds: duration,
        pages_viewed: sessionPageCount,
      });
      // Use sendBeacon for reliable delivery on page close
      navigator.sendBeacon(`${API}/analytics/session-end`, data);
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, []);
}
